import { isSkinnyInstallType } from "./helper";
import { needsCloseCodes, needsNoAccessReason, isSrOrDi, isSr } from "../utils/serviceTypeUtils";
const apiUrls = require('../constants/apiUrls');

export default class StepConfig {
  constructor(currentStatus, serviceTypeId, isFiberOrCommercial, isCustomerDetailMissing) {
    this.orderStatusStepConfig = {
      validationKey: "orderStatus",
      stepKey: "orderStatusStepConfig",
    };

    this.commentStepConfig = {
      validationKey: "comment",
      stepKey: "commentStepConfig",
    };

    this.chargesStepConfig = {
      validationKey: "charges",
      stepKey: "chargesStepConfig",
    };

    this.sqcStepConfig = {
      validationKey: "sqc",
      stepKey: "sqcStepConfig",
    };

    this.closeCodeStepConfig = {
      validationKey: "closeCodes",
      stepKey: "closeCodeStepConfig",
    };

    this.dropBuryStepConfig = {
      validationKey: "dropBury",
      stepKey: "dropBuryStepConfig",
    };

    this.insideHomeAccessStepConfig = {
      validationKey: "insideHomeAccess",
      stepKey: "insideHomeAccessStepConfig",
    };

    this.pmStepConfig = {
      validationKey: "pmTicket",
      stepKey: "pmStepConfig",
    };

    this.truckRollStepConfig = {
      validationKey: "truckRoll",
      stepKey: "truckRollStepConfig",
    };

    this.fstSignalStepConfig = {
      validationKey: "signalLevels",
      stepKey: "fstSignalStepConfig",
    };

    this.deliveryProofStepConfig = {
      validationKey: 'deliveryProof',
      stepKey: 'deliveryProofStepConfig'
    };

    this.noAccessReasonStepConfig = {
      validationKey: 'noAccessReason',
      stepKey: 'noAccessReasonStepConfig'
    };

    this.outletOptimizationStatusStepConfig = {
      validationKey: 'outletOptimization',
      stepKey: 'outletOptimizationStepConfig'
    };

    this.stepConfig = [
      this.orderStatusStepConfig,
      this.chargesStepConfig,
      this.commentStepConfig,
      this.sqcStepConfig,
      this.closeCodeStepConfig,
      this.dropBuryStepConfig,
      this.insideHomeAccessStepConfig,
      this.pmStepConfig,
      this.truckRollStepConfig,
      this.outletOptimizationStatusStepConfig,
      this.fstSignalStepConfig,
      this.deliveryProofStepConfig,
      this.noAccessReasonStepConfig
    ];

    this.setCloseStepIndex(currentStatus, serviceTypeId, isFiberOrCommercial, isCustomerDetailMissing);
  }

  getSkinnyInstalIndex(index, serviceTypeId) {
    return isSkinnyInstallType(serviceTypeId) ? -1 : index++;
  }

  setCloseStepIndex(currentStatus, serviceTypeId, isFiberOrCommercial, isCustomerDetailMissing) {
    let index = 0;
    this.orderStatusStepConfig.index = index++;

    if (currentStatus === "NoAccess") {
      this.noAccessReasonStepConfig.index = needsNoAccessReason(serviceTypeId) ? index++ : -1;
      this.commentStepConfig.index = index++;
      this.chargesStepConfig.index = index++;
      this.sqcStepConfig.index = -1;
      this.truckRollStepConfig.index = index++;
      this.closeCodeStepConfig.index = -1;
      this.dropBuryStepConfig.index = -1;
      this.insideHomeAccessStepConfig.index = -1;
      this.pmStepConfig.index = index++;
      this.fstSignalStepConfig.index = -1;
      this.deliveryProofStepConfig.index = -1;
      this.outletOptimizationStatusStepConfig.index = -1;
    } else {
      this.noAccessReasonStepConfig.index = -1;
      this.commentStepConfig.index = index++;
      this.chargesStepConfig.index = index++;
      this.sqcStepConfig.index = this.getSkinnyInstalIndex(index, serviceTypeId);
      this.pmStepConfig.index = index++;
      this.fstSignalStepConfig.index = apiUrls.BYPASS_SIGNAL_LEVELS ? -1 : index++;
      this.dropBuryStepConfig.index = index++;

      if(!isFiberOrCommercial && !isSkinnyInstallType(serviceTypeId)) {
        this.outletOptimizationStatusStepConfig.index = index++;
      }

      this.truckRollStepConfig.index = index++;

      if (!needsCloseCodes(serviceTypeId)) {
        // non-TC
        this.closeCodeStepConfig.index = -1;
        this.insideHomeAccessStepConfig.index = this.getSkinnyInstalIndex(
          index,
          serviceTypeId
        );

      } else {
        //TC needs close code
        this.closeCodeStepConfig.index = index++;
        this.insideHomeAccessStepConfig.index = this.getSkinnyInstalIndex(
          index,
          serviceTypeId
        );

      }
      this.deliveryProofStepConfig.index = isSkinnyInstallType(serviceTypeId) ? index++ : -1;

    }

    //pm ticket needs Close Codes, but not mt ticket or sqc
    if (isSrOrDi(serviceTypeId)) {
      this.noAccessReasonStepConfig.index = -1;
      this.commentStepConfig.index = 1;
      this.chargesStepConfig.index = 2;
      this.sqcStepConfig.index = -1;
      this.pmStepConfig.index = 3;
      this.dropBuryStepConfig.index = 4;
      this.fstSignalStepConfig.index = -1;
      this.deliveryProofStepConfig.index = -1;
      if(isSr(serviceTypeId)) {
      this.outletOptimizationStatusStepConfig.index = -1;
      this.insideHomeAccessStepConfig.index = 6;
      if (currentStatus === "Cancel") {
        this.truckRollStepConfig.index = 5;
        this.closeCodeStepConfig.index = -1;
      } else {
        this.truckRollStepConfig.index = 5;
        this.closeCodeStepConfig.index = 7;
      }
      } else{
        this.outletOptimizationStatusStepConfig.index = 6;
        this.insideHomeAccessStepConfig.index = 7;
        if (currentStatus === "Cancel") {
          this.truckRollStepConfig.index = 5;
          this.closeCodeStepConfig.index = -1;
        } else {
          this.truckRollStepConfig.index = 5;
          this.closeCodeStepConfig.index = 8;
        }
      }
    }

    if(isCustomerDetailMissing){
      index = 0;
      this.orderStatusStepConfig.index = index++;
      this.noAccessReasonStepConfig.index = -1;
      this.commentStepConfig.index = index++;
      this.chargesStepConfig.index = -1;
      this.sqcStepConfig.index = -1;
      this.truckRollStepConfig.index = -1;
      this.closeCodeStepConfig.index = -1;
      this.dropBuryStepConfig.index = -1;
      this.insideHomeAccessStepConfig.index = -1;
      this.pmStepConfig.index = -1;
      this.fstSignalStepConfig.index = -1;
      this.deliveryProofStepConfig.index = -1;
      this.outletOptimizationStatusStepConfig.index = -1;
    }

    this.stepConfig = this.stepConfig.sort((a, b) => {
      if (a.index < b.index) {
        return -1;
      }

      if (a.index > b.index) {
        return 1;
      }

      return 0;
    });

    const steps = [];

    this.stepConfig.forEach((step) => {
      if (step.index >= 0) {
        steps.push(step);
      }
    });

    this.stepConfig = steps;
  }

  checkAllPreviousStepsValid(indexToCheck, orderCloseDetails) {
    let allPreviousStepsValid = true;
    if (orderCloseDetails) {
      for (let index = 0; index < indexToCheck; index++) {
        const stepValidation = orderCloseDetails.getIn([
          "stepValidation",
          this.stepConfig[index].validationKey,
        ]);

        if (!stepValidation.get("isValid")) {
          allPreviousStepsValid = false;
        }
      }
    }

    return allPreviousStepsValid;
  }

  checkStepVaild(currentIndex, orderCloseDetails) {
    let step = null;

    this.stepConfig.forEach((item) => {
      if (item.index === currentIndex) {
        step = item;
      }
    });

    if (step) {
      const stepValidation = orderCloseDetails.getIn([
        "stepValidation",
        step.validationKey,
      ]);

      return stepValidation.get("isValid");
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/utils/stepConfig.js